var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");
var StudentExpectationsDisplay = require('components/users/students/StudentExpectationsDisplay');
var StudentProgressDisplay = require("components/users/students/StudentProgressDisplay");

class StudentOnboardingImage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { activeHat: null, confirmedHat: false };
	}

	stageImgKey() {
		var imgKey = this.props.imgPath;

		if (imgKey && imgKey.includes("{{LEVEL}}")) {
			imgKey = imgKey.replace("{{LEVEL}}", this.props.level);
		}

		return imgKey;
	}

	showHatOnOwl(hatKey) {
		this.setState({ activeHat: hatKey });			
	}
	renderHat(hatKey) {
		var hatImgPath = dynamicRequire("patches/head/" + hatKey + "-s.png");
		return (
			<img src={ hatImgPath } alt={ hatKey } className="hatImg clickableElement"
				onClick={ this.showHatOnOwl.bind(this, hatKey) } key={ hatKey } />
		);
	}
	renderStudentAvatarHatsDisplay() {
		var hatImages = _.map(["hat-1", "hat-2", "hat-3", "hat-4"], (hatKey) => {
			return this.renderHat(hatKey);
		});

		if (this.state.activeHat) {
			var activeHatDisplay = (
				<img src={ dynamicRequire("patches/head/" + this.state.activeHat + ".png") } className="activeHat" />
			);
		}

		return (
			<div className="stage-student-avatar-hats">
				<div className="hatContainer">
					{ hatImages }
				</div>
				{ activeHatDisplay }
				<StudentAvatar student={ CurrentUser.get() } maxWidth={ 200 } />
			</div>
		);
	}
	renderStudentExpectationsDisplay() {

		// <StudentExpectationsDisplay studentID={ CurrentUser.get().id } />
		return (
			<div className="expectationsContainer">
				<StudentProgressDisplay
								metric={ "quizzes-passed" }
								title={ "Quizzes Passed" }
								unit={ "quizzes" }
								total={ 1 }
								current={ 0 }
								actionLabel={ "Take a Quiz" }/>
				<StudentProgressDisplay
								metric={ "questions" }
								title={ "Practice Questions" }
								unit={ "answers" }
								total={ 1 }
								current={ 0 }
								actionLabel={ "Answer a Question" }/>
			</div>
		)
	}

	render() {
		var imgKey = this.stageImgKey();
		var className = "studentOnboardingImage";

		// custom display for student avatar with hats and with rays
		if (imgKey && imgKey.includes("student-avatar")) {
			if (imgKey.includes("hats")) {
				var imgDisplay = this.renderStudentAvatarHatsDisplay();
			} else if (imgKey.includes("rays")) {
				var imgDisplay = (
					<div className="stage-student-avatar-rays">
						<img src={ require("onboarding/owlfonso-waving.png") } alt="owlfonso"
							className="owlfonsoWaving" />
						<StudentAvatar student={ CurrentUser.get() } maxWidth={ 200 } />
					</div>
				);
			}
		} else if (imgKey && imgKey.includes("profile-action-buttons")) {
			var imgDisplay = this.renderStudentExpectationsDisplay();
			className += " studentExpectationsDisplay";
		} else if (imgKey) {
			var imgClass = "stage-" + imgKey;
			var imgPath = dynamicRequire("onboarding/" + imgKey + ".png");
			var imgDisplay = <img src={ imgPath } alt="welcome" className={ imgClass } />;
		}

		return (
			<div className={ className }>
				{ imgDisplay }
			</div>
		);
	}

	componentDidUpdate(prevProps) {
		if ((prevProps.stage != this.props.stage) && (this.state.activeHat != null) && (prevProps.hasStudentOptions) 
			&& (prevProps.imgPath == 'student-avatar-hats')) {
			var award_data = {
				type: "onboarding_hat", student_id: CurrentUser.get().id,
				patch_name: this.state.activeHat
			};

			this.setState({ confirmedHat: true });
			CurrentUser.api().postAwards({ award: award_data }, $wr.apiHandler((response) => {
				CurrentUser.fetchCurrentUserData();
			}));
		}
	}
}

StudentOnboardingImage.propTypes = StrictPropTypes({
	stage: PropTypes.number.isRequired,
	level: PropTypes.string.isRequired,
	hasStudentOptions: PropTypes.bool,
	imgPath: PropTypes.string,
});

module.exports = StudentOnboardingImage;


// WEBPACK FOOTER //
// ./modules/components/users/students/onboarding/StudentOnboardingImage.js